;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { pluralize } from '@qogita/format/string'
import { Anchor } from '@qogita/ui/v2/anchor'
import { Badge } from '@qogita/ui/v2/badge'
import { Icon } from '@qogita/ui/v2/icon'
import clsx from 'clsx'
import { Suspense } from 'react'
import { OrderExpiryTimeBadge } from 'src/components/order-expiry-time-badge'
import { getFormattedCurrencyWithSymbol } from 'src/deprecated/utils/getFormattedCurrency'
import { trackDashboardExpiringOrderClicked } from 'src/deprecated/utils/report/tracking'
import { routes } from 'src/deprecated/utils/routes'

import { useExpiringAndUnreadOrders } from '../hooks/useExpiringAndUnreadOrders'

type Props = { className?: string }

function ExpiringOrdersInner() {
  const {
    expiring: { sales, totalResults },
  } = useExpiringAndUnreadOrders()

  return (
    <div className={clsx({ 'pb-6': sales.length > 0 })}>
      <div
        className={clsx('flex flex-row items-center p-6', {
          'pb-3': sales.length > 0,
        })}
      >
        <Icon
          name="heroicons/outline/exclamation-triangle"
          // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
          className="text-caution-700 mr-3 size-6"
        />
        <h3 className="typography-header-lg-bold flex items-center leading-7">
          {pluralize({ word: 'expiring order', count: totalResults })}
        </h3>
      </div>

      <div className="max-h-60 overflow-y-auto px-6">
        <table className="w-full">
          <thead className="sr-only">
            <tr>
              <th>Order number</th>
            </tr>

            <tr>
              <th>Total price</th>
            </tr>

            <tr>
              <th>Expiry in hours</th>
            </tr>
          </thead>

          <tbody>
            {sales.map((order) => {
              const formattedTotal = getFormattedCurrencyWithSymbol(
                +order.total,
                order.metadata.currency,
              )

              return (
                <tr key={order.qid} className="h-[48px]">
                  <td className="flex flex-wrap items-center gap-x-2">
                    <Anchor
                      href={routes.order(order.qid)}
                      color="primary"
                      variant="text"
                      // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
                      className="font-normal"
                      onClick={() => {
                        trackDashboardExpiringOrderClicked(order)
                      }}
                    >
                      {order.order}
                    </Anchor>
                  </td>

                  <td>
                    {order.isEnterprisePackaging ? (
                      <Badge
                        emphasis="high"
                        variant="feature"
                        icon="heroicons/outline/check-badge"
                        help="High priority, Enterprise packaging standards required"
                      >
                        Enterprise
                      </Badge>
                    ) : null}
                  </td>

                  <td className="px-6">
                    <p className="flex justify-end text-gray-700">
                      {formattedTotal}
                    </p>
                  </td>

                  <td className="flex justify-end">
                    <OrderExpiryTimeBadge expiredAt={order.expiredAt} />
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

function Fallback() {
  return (
    <div className="flex flex-row items-center p-6">
      <div className="mr-3 rounded-xs bg-gray-200 motion-safe:animate-pulse">
        <Icon
          name="heroicons/outline/exclamation-triangle"
          // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
          className="text-caution-700 invisible mr-3 size-6"
        />
      </div>
      <div className="rounded-xs bg-gray-200 motion-safe:animate-pulse">
        <h3 className="readSales invisible flex items-center text-base font-bold">
          {pluralize({ word: 'expiringOrder', count: 3 })}
        </h3>
      </div>
    </div>
  )
}

export function ExpiringOrders({ className }: Props) {
  return (
    <article
      className={clsx(
        className,
        'relative rounded-lg border border-gray-200 bg-white shadow-xs',
      )}
    >
      <Suspense fallback={<Fallback />}>
        <ExpiringOrdersInner />
      </Suspense>
    </article>
  )
}
